import React, { useContext, useEffect } from 'react';
import DailyEngagedUsersContext from '../../../../contexts/DailyEngagedUsersContext';
import { CompiledDailyEngagedUserPaper, CompiledDailyEngagedUsersRow } from '../styles';
import CompiledDailyEngagedUserTitle from './CompiledDailyEngagedUserTitle';
import CompiledDailyEngagedUserOverspentContent from './CompiledDailyEngagedUserOverspentContent';
import { PageHeaderComponent } from '../../components/Metrics/PageHeader/PageHeaderComponent';
import { origin, REPORT_PERIOD_SELECT } from '../../../../shared/SegmentEvents';
import { trackEvent } from '../../../../api/Billing/Tracking';
import { useDeuConsumptionContext } from '../../../../contexts/Billing/DeuConsumptionContext';
import { BlipLoadingComponent } from '../../../../components/BlipLoading/BlipLoadingComponent';

const CompiledDailyEngagedUsersComponent: React.FC = () => {
  const {
    content,
    dateToSearch,
    tenant,
    trackingProps,
    loggedUser,
    getPlanStatus,
    periodOptions,
    setDateToSearch,
    isMetricAllowed,
  } = useContext(DailyEngagedUsersContext);
  const { compiledDailyEngagedUserDataState, isDeuLoading, consolidatedDeuApiRequisition } = useDeuConsumptionContext();

  useEffect(() => {
    consolidatedDeuApiRequisition(dateToSearch, (metrics) =>
      metrics.some((metric) => isMetricAllowed(metric))
    );
  }, [dateToSearch, isMetricAllowed]);

  const dailyMetric = compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.find(
    item => item.metric.metricId === 'DailyEngagedUser'
  );

  const exceededPlan = dailyMetric?.exceededPlan ?? 0;

  const periodOptionChangeEvent = async (selectedOption) => {
    const dateToRetrieveData = new Date(selectedOption.detail.value);
    setDateToSearch(dateToRetrieveData);
    const planStatus = await getPlanStatus();
    trackEvent(REPORT_PERIOD_SELECT, tenant, loggedUser, {
      ...trackingProps,
      origin: origin.DEU,
      date: dateToRetrieveData,
      planStatus: planStatus,
    });
  };

  return (
    <>
      <PageHeaderComponent
        title={content.title}
        dateToSearch={dateToSearch}
        periodOptions={periodOptions}
        periodOptionChangeEvent={periodOptionChangeEvent}
      />
      <CompiledDailyEngagedUserPaper>
        <div>
          <CompiledDailyEngagedUserTitle></CompiledDailyEngagedUserTitle>
          <CompiledDailyEngagedUsersRow>
            {isDeuLoading ? (
              <BlipLoadingComponent />
            ) : (
              <>
                {exceededPlan > 0 && (
                  <CompiledDailyEngagedUserOverspentContent></CompiledDailyEngagedUserOverspentContent>
                )}
              </>
            )}
          </CompiledDailyEngagedUsersRow>
        </div>
      </CompiledDailyEngagedUserPaper>
    </>
  );
};

export default CompiledDailyEngagedUsersComponent;
